import styled from "styled-components";
import { ProfileCashierButtonDefaultBox } from "../profile-cashier-button.default.box";

export const ProfileCashierAddButtonDefaultBox = styled.div`
    display: block;
    position: absolute;
    top: 50%;
    right: 7px;
    transition: all 0.2s ease-in-out;
    transform: translateY(-50%);
    ${ProfileCashierButtonDefaultBox}:hover & {
        transform: translateY(-50%) rotate(180deg);
    }
    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlAndBelow} {
        right: 4px;
        ${ProfileCashierButtonDefaultBox}:hover & {
            transform: translateY(-50%) rotate(180deg) scale(1.2);
        }
    }
`;
